export default __webpack_public_path__ + "static/media/merge_blanco_transparente.b6b3140f.png";